<template>
    <div class="companyList">
        <div>
            <div class="fz18 c333">公司认证</div>
            <div class="fz18 blue" @click="goRouter('/company')">+添加新公司认证</div>
        </div>
        <div class="list">
            <div class="item" v-for="(item,index) in list" v-if="item.isPerson<5" :key="index" @click="detail(item)">
                <div>
                    <div class="mine" v-if="item.isMain=='1'">
                        <div><i class="el-icon-user"></i></div>
                        <div>主账户</div>
                    </div>
                    <div class="noMine" v-if="item.isMain!='1'"><i class="el-icon-office-building"></i></div>
                </div>
                <div class="fz18 c333 fwB">
                    {{item.companyName}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CompanyList",
        data() {
            return {
                list: []
            };
        },
        created() {
            this.getList();
        },
        methods: {
            detail(item) {
                this.$router.push({
                    path: '/company',
                    query: {
                        id: item.userId
                    }
                })
            },
            getCompanyInfo() {
                this.request.get(this.$store.state.httpUrl + "userDetails/findCompany", {
                    params: {
                        id: this.$store.state.userId,
                    }
                }).then(res => {
                    if (res.status == 200) {
                        res.data.isMain = '1';
                        this.list.push(res.data);
                    }
                });
            },
            getList() {
                let params = {
                    telnum: this.$store.state.telNum,
                    pwd: sessionStorage.getItem('pwd'),
                    clientId: '',
                }

                this.request({
                    method: 'post',
                    url: this.$store.state.httpUrl + "mobileInterf/loginMultipleAccounts",
                    params
                }).then(res => {
                    if (res.status == 200) {
                        if (res.flag == 1) {
                            this.list = res.data;
                        } else {
                            this.list.push(res.data);
                        }
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .companyList {
        padding: 0 24px;
        text-align: left;
    }

    .companyList>div:nth-child(1) {
        line-height: 70px;
        border-bottom: 1px solid #E6E6E6;
        display: flex;
        justify-content: space-between;
    }

    .companyList>div:nth-child(1)>div:nth-child(2) {
        cursor: pointer;
    }

    .list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-top: 28px;
    }

    .item {
        width: 418px;
        height: 102px;
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        border-radius: 5px;
        padding: 12px 18px;
        box-sizing: border-box;
        margin-bottom: 20px;
    }

    .item>div:nth-child(2) {
        margin-top: 16px;
    }

    .mine {
        width: 84px;
        height: 30px;
        background: #FFE4CE;
        border-radius: 15px;
        padding: 5px;
        display: flex;
        box-sizing: border-box;
    }

    .mine>div:nth-child(1) {
        width: 20px;
        height: 20px;
        background: linear-gradient(90deg, #FF7C3B 0%, #FF864A 100%);
        border-radius: 50%;
        text-align: center;
        line-height: 20px;
        color: #FFFFFF;
        font-size: 12px;
    }

    .mine>div:nth-child(2) {
        line-height: 20px;
        font-size: 14px;
        font-weight: bold;
        color: #FF6316;
        padding-left: 5px;
    }

    .noMine {
        width: 30px;
        height: 30px;
        background: #DEE9FF;
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        color: #5C92FF;
    }
</style>



// WEBPACK FOOTER //
// src/view/me/companyList.vue